import { useEffect, useState } from "react";
// import { Badge } from "flowbite-react";
import { EmptyState, LoadingSkeleton } from "./components";
import { getPendingRequests } from "../../services/merchManager/merchManagerActions";
import { usePaginate } from "../../hooks/usePaginate";
import { useAutoSelectFromUrl } from "../../hooks/useAutoSelectFromUrl";

const PendingRequests = ({
  merch,
  updateAPI,
  selectedRequest,
  setSelectedRequest,
  onLoadingChange,
  targetRequestId,
}) => {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { showingItems, PaginateBtn } = usePaginate(pendingRequests, null);
  const { itemRefs, notFound, listToRender, returnLink } = useAutoSelectFromUrl(
    pendingRequests,
    targetRequestId,
    setSelectedRequest,
    showingItems,
  );

  useEffect(() => {
    onLoadingChange?.(true);
    getPendingRequests({ setIsLoading }).then((res) => {
      setPendingRequests(res);
      onLoadingChange?.(false);
      // keep selected in sync
      setSelectedRequest((prev) =>
        prev
          ? (res.find((m) => m.id === prev.id) ?? res[0] ?? null)
          : (res[0] ?? null),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateAPI]);

  return (
    <>
      {isLoading ? (
        <LoadingSkeleton />
      ) : pendingRequests.length === 0 ? (
        <EmptyState
          icon={
            <svg
              className="w-10 h-10"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          }
          text="No pending requests — all caught up!"
        />
      ) : (
        <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
          {notFound && (
            <div className="rounded-lg bg-yellow-50 border border-yellow-200 px-4 py-3 text-sm text-yellow-800 mb-3">
              This request <b>{targetRequestId}</b> wasn't found here — it may
              have already been actioned or doesn't belong to this tab.
            </div>
          )}
          {returnLink}
          {listToRender.map((req) => {
            const item = merch.find((m) => m.id === req.item_id);
            const isSelected = selectedRequest?.id === req.id;
            return (
              <button
                id={req.id}
                key={req.id}
                onClick={() => {
                  setSelectedRequest(req);
                }}
                ref={(el) => (itemRefs.current[req.id] = el)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-all ${
                  isSelected
                    ? "border-primary bg-primary/5 dark:bg-primary/10"
                    : "border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600"
                }`}
              >
                {/* Item thumbnail */}
                {item?.assets?.[0] ? (
                  <img
                    src={item.assets[0].url}
                    alt=""
                    className="w-10 h-10 rounded-lg object-cover shrink-0"
                  />
                ) : (
                  <div className="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center shrink-0">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                )}
                {/* Info */}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                    {req.requested_by}
                  </p>
                  <p className="text-xs text-gray-400 truncate">
                    {req?.item_name ?? "Unknown item"} · {req.item_count}{" "}
                    requested
                  </p>
                </div>
                {/* Team badge */}
                <div>
                  <p className="text-[11px] text-gray-400 whitespace-nowrap">
                    {req.updatedAt
                      ? req.updatedAt.toDate().toLocaleDateString("en-AU", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })
                      : "-"}
                  </p>
                </div>
                {/*   <Badge
                  color={req.requester_team === "sales" ? "purple" : "gray"}
                  size="xs"
                  className="capitalize shrink-0"
                >
                  {req.requester_team ?? "other"}
                </Badge> */}
              </button>
            );
          })}
          <div className="flex justify-center">
            <PaginateBtn />
          </div>
        </div>
      )}
    </>
  );
};

export default PendingRequests;
